module.exports = __webpack_public_path__ + "img/g-logo-col.bdc08f45.png";